<template>
  <va-card :title="$t('events.locationUsers')" stripe="warning">
    <template slot="actions">
      <va-button color="warning" @click="createModal" icon="fa fa-plus"/>
      <va-button color="warning" to="/admin/app-users" icon="fa fa-eye"/>
    </template>
    <UserCreateModal @closemodal="closeModal" @update="updateUser" :location-id="locationId" :open-modal="openCreateModal"/>
    <div class="row align--center mb-1">
      <div class="flex xs12 sm6">
        <va-input
          class="ma-0"
          :value="term"
          placeholder="Filter user data"
          @input="search"
          removable
        >
          <va-icon name="fa fa-search" slot="prepend" />
        </va-input>
      </div>
    </div>
    <va-data-table
      :fields="fields"
      :data="filteredData"
      :loading="loading"
      hoverable
    >
      <template slot="icon">
        <va-icon name="fa fa-user" color="secondary" />
      </template>
    </va-data-table>
  </va-card>
</template>

<script>
import debounce from 'lodash/debounce'
import UserCreateModal from '../modals/UserCreateModal'
export default {
  name: 'UsersLocationTable',
  components: { UserCreateModal },
  data () {
    return {
      openCreateModal: false,
      users: [].slice(),
      loading: false,
      term: null,
      mode: 0,
    }
  },
  props: {
    lusers: Array,
    locationId: Number,
  },
  computed: {
    fields () {
      return [{
        name: '__slot:icon',
        width: '30px',
        dataClass: 'text-center',
      }, {
        name: 'name',
        title: 'name',
        width: '30%',
      },
      {
        name: 'surname',
        title: 'surname',
        width: '30%',
      }, {
        name: 'email',
        title: 'email',
        width: '30%',
      }]
    },
    modeOptions () {
      return [{
        value: 0,
        label: this.$t('dashboard.table.brief'),
      }]
    },
    filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.users
      }

      return this.users.filter(item => {
        return item.name.toLowerCase().startsWith(this.term.toLowerCase()) ||
          item.surname.toLowerCase().startsWith(this.term.toLowerCase()) ||
          item.email.toLowerCase().startsWith(this.term.toLowerCase())
      })
    },
  },
  methods: {
    async createModal () {
      this.openCreateModal = true
    },
    async closeModal (state) {
      this.openCreateModal = state
    },
    updateUser (user) {
      this.users.splice(this.users.length, -1, user)
    },
    getStatusColor (status) {
      if (status === 'paid') {
        return 'success'
      }

      if (status === 'processing') {
        return 'info'
      }

      return 'danger'
    },
    resolveUser (user) {
      this.loading = true

      setTimeout(() => {
        const idx = this.users.findIndex(u => u.id === user.id)
        this.users.splice(idx, 1)
        this.loading = false

        this.showToast(this.$t('dashboard.table.resolved'), {
          icon: 'fa-check',
          position: 'bottom-right',
          duration: 1500,
        })
      }, 500)
    },
    search: debounce(function (term) {
      this.term = term
    }, 400),
  },
  mounted () {
    this.users = this.lusers.slice()
  },
}
</script>

<style lang="scss">
</style>
